import ApiBase from './Api'
import {
    DeleteWatchListItemRequest,
    GetWatchListRequest,
    PostWatchListRequest,
    WatchListItemType,
} from '@finance-lab/utils/types'

const BASE_PATH = '/watch-lists'

export class WatchListsApi extends ApiBase {
    async getAll() {
        return this._getRequest<GetWatchListRequest>(BASE_PATH)
    }

    async createItem(type: WatchListItemType, id: string) {
        return this._postRequest<PostWatchListRequest>(BASE_PATH, { entityType: type, entityId: id })
    }

    async deleteItem(type: WatchListItemType, id: string) {
        return this._deleteRequest<DeleteWatchListItemRequest>(BASE_PATH, {
            queryParameters: { entityType: type, entityId: id },
        })
    }
}
